import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Progress, Text, Box, Image, Center, Button, Select, Spinner } from "@chakra-ui/react";
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
  } from '@chakra-ui/react';
import axios from "axios";

const Statistics = () => {

    const {id, home, away} = useParams();

    const [firstTeam, setFirstTeam] = useState([]);
    const [firstTeamPic, setFirstTeamPic] = useState("");
    const [firstTeamName, setFirstTeamName] = useState("");
    const [secondTeam, setSecondTeam] = useState([]);
    const [secondTeamPic, setSecondTeamPic] = useState("");
    const [secondTeamName, setSecondTeamName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const FOOTBALL_KEY = process.env.REACT_APP_FOOTBALL_API_KEY;

    useEffect(() => {
        setLoading(true);
        let URL = `https://v3.football.api-sports.io/fixtures/statistics?fixture=${id}`;
        // ! axios config
        let config: any = {
            method: 'get',
            url: URL,
            headers: { 
            'x-rapidapi-host': 'v3.football.api-sports.io', 
            'x-rapidapi-key': `${FOOTBALL_KEY}`
            }
        };

        axios(config)
        .then((result) => {
            console.log(result);
            if(result.data) {
                if(result.data.response[0] && result.data.response[1]) {
                    setFirstTeam(result.data.response[0].statistics);
                    setFirstTeamPic(result.data.response[0].team.logo);
                    setFirstTeamName(result.data.response[0].team.name);
                    setSecondTeam(result.data.response[1].statistics);
                    setSecondTeamPic(result.data.response[1].team.logo);
                    setSecondTeamName(result.data.response[1].team.name);
                }
            }
            setLoading(false);
        })
        .catch((error)=> {
            console.log(error);
            setLoading(false);
        })
    },[])

    return (
        <Container maxW='container.sm' pt='10' pb='20'>

            {error &&
            <Text textAlign="center">
                Failed to fetch data.
            </Text>
            }

            {loading ? 
            <Center>
                <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='blue.600'
                size='xl'
                mt={["50%","10%"]}
                />
            </Center>
            :
            <>
            {firstTeamName && secondTeamName ?
            <Box display="flex" color="#ffffff" justifyContent="space-between">
                <Box>
                <Image
                    boxSize='100px'
                    objectFit='cover'
                    src={firstTeamPic}
                    alt='Dan Abramov'
                />
                <Text mt="5" textAlign="center">{firstTeamName}</Text>
                </Box>
                <Box>
                    <Text mt='8' fontSize='4xl' fontWeight="600">{home} - {away}</Text>
                    <Text mt='1' textAlign="center" fontSize="xs">Full Time</Text>
                </Box>
                <Box>
                <Image
                    boxSize='100px'
                    objectFit='cover'
                    src={secondTeamPic}
                    alt='Dan Abramov'
                />
                <Text mt="5" textAlign="center">{secondTeamName}</Text>
                </Box>
            </Box>
            :
            <></>}

            <TableContainer mt='8'>
            <Table variant='simple'>
                {firstTeam.length > 0 && secondTeam.length ?
                <Tbody color="#ffffff" fontSize="sm">
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[9].value}</Td>
                        <Td w="80%" textAlign="center">POSSESSION</Td>
                        <Td w="10%" textAlign="center">{secondTeam[9].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[13].value}</Td>
                        <Td w="80%" textAlign="center">TOTAL PASSES</Td>
                        <Td w="10%" textAlign="center">{secondTeam[13].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[14].value}</Td>
                        <Td w="80%" textAlign="center">ACCURATE PASSES</Td>
                        <Td w="10%" textAlign="center">{secondTeam[14].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[2].value === null ? 0 : firstTeam[2].value}</Td>
                        <Td w="80%" textAlign="center">TOTAL SHOTS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[2].value === null ? 0 : secondTeam[2].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[0].value === null ? 0 : firstTeam[0].value}</Td>
                        <Td w="80%" textAlign="center">SHOTS ON TARGET</Td>
                        <Td w="10%" textAlign="center">{secondTeam[0].value === null ? 0 : secondTeam[0].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[1].value === null ? 0 : firstTeam[1].value}</Td>
                        <Td w="80%" textAlign="center">SHOTS OFF GOAL</Td>
                        <Td w="10%" textAlign="center">{secondTeam[1].value === null ? 0 : secondTeam[1].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[3].value === null ? 0 : firstTeam[3].value}</Td>
                        <Td w="80%" textAlign="center">BLOCKED SHOTS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[3].value === null ? 0 : secondTeam[3].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[12].value === null ? 0 : firstTeam[12].value}</Td>
                        <Td w="80%" textAlign="center">SAVES</Td>
                        <Td w="10%" textAlign="center">{secondTeam[12].value === null ? 0 : secondTeam[12].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[7].value === null ? 0 : firstTeam[7].value}</Td>
                        <Td w="80%" textAlign="center">CORNER KICKS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[7].value === null ? 0 : secondTeam[7].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[6].value === null ? 0 : firstTeam[6].value}</Td>
                        <Td w="80%" textAlign="center">FOULS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[6].value === null ? 0 : secondTeam[6].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[8].value === null ? 0 : firstTeam[8].value}</Td>
                        <Td w="80%" textAlign="center">OFFSIDES</Td>
                        <Td w="10%" textAlign="center">{secondTeam[8].value === null ? 0 : secondTeam[8].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[10].value === null ? 0 : firstTeam[10].value}</Td>
                        <Td w="80%" textAlign="center">YELLOW CARDS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[10].value === null ? 0 : secondTeam[10].value}</Td>
                    </Tr>
                    <Tr w="100%">
                        <Td w="10%" textAlign="center">{firstTeam[11].value === null ? 0 : firstTeam[11].value}</Td>
                        <Td w="80%" textAlign="center">RED CARDS</Td>
                        <Td w="10%" textAlign="center">{secondTeam[11].value === null ? 0 : secondTeam[11].value}</Td>
                    </Tr>
                </Tbody>
                :
                <></>}
            </Table>
            </TableContainer>
            </>}

        </Container>
    );
}
 
export default Statistics;